<template>
  <div class="container">
    <a href="#" class="site-name">
      <router-link :to="{ name: 'Home' }">
        <!-- Generator: Adobe Illustrator 24.1.0, SVG Export Plug-In  -->
        <svg
          class="hidden sm:block lg-logo"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="907.4468px"
          height="116.1387px"
          viewBox="0 0 907.4468 116.1387"
          style="enable-background:new 0 0 907.4468 116.1387;"
          xml:space="preserve"
        >
          <defs />
          <rect
            x="1"
            y="1"
            style="fill:#33322D;stroke:#33322D;stroke-width:2;stroke-miterlimit:10;"
            width="361.5918"
            height="114.1387"
          />
          <rect
            x="362.5918"
            y="1"
            style="fill:#FFFFFF;stroke:#33322D;stroke-width:2;stroke-miterlimit:10;"
            width="543.855"
            height="114.1387"
          />
          <g>
            <path
              style="fill:#FFFFFF;"
              d="M72.5215,71.9766c-0.3301,3.4639-1.1553,6.624-2.4746,9.4775
          c-1.3203,2.8545-3.0684,5.2959-5.2461,7.3252s-4.7441,3.5967-7.6963,4.7012c-2.9531,1.1055-6.2451,1.6582-9.874,1.6582
          c-4.3887,0-8.2158-0.8496-11.4824-2.5488c-3.2656-1.6992-5.9883-4-8.1655-6.9043c-2.1777-2.9033-3.811-6.3018-4.8999-10.1953
          C21.5938,71.5977,21.0322,67.4404,21,63.0186v-9.8496c0.0322-4.3877,0.6099-8.5371,1.7319-12.4473
          c1.1216-3.9092,2.7793-7.3242,4.9741-10.2441c2.1943-2.9199,4.9248-5.2295,8.1914-6.9287C39.1631,21.8496,42.957,21,47.2803,21
          c3.7939,0,7.1758,0.5605,10.1455,1.6826s5.5098,2.7051,7.6221,4.751c2.1113,2.0459,3.7939,4.5371,5.0479,7.4736
          s2.0615,6.2031,2.4258,9.7988H60.6426c-0.1973-2.1113-0.6016-4.0332-1.2119-5.7656c-0.6113-1.7324-1.4443-3.2168-2.5-4.4541
          s-2.3838-2.1855-3.9834-2.8457c-1.6006-0.6602-3.4893-0.9902-5.667-0.9902c-2.6729,0-4.917,0.6113-6.7314,1.8311
          c-1.8145,1.2217-3.2832,2.8633-4.4043,4.9248c-1.1221,2.0625-1.9229,4.4463-2.4004,7.1514
          c-0.4785,2.7061-0.7178,5.543-0.7178,8.5127v9.9482c0,3.1016,0.2393,6.0127,0.7178,8.7354
          c0.4775,2.7217,1.2617,5.1064,2.3506,7.1514c1.0889,2.0459,2.541,3.6621,4.3555,4.8506c1.8145,1.1875,4.0742,1.7812,6.7803,1.7812
          c4.1572,0,7.3252-1.1787,9.5029-3.5381s3.4639-5.7002,3.8604-10.0225H72.5215z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M133.5449,62.7217c0,4.2559-0.5439,8.3389-1.6328,12.249s-2.7148,7.3584-4.875,10.3438
          c-2.1611,2.9863-4.8672,5.3623-8.1172,7.127s-7.0518,2.6475-11.4072,2.6475c-4.3232,0-8.085-0.8906-11.2842-2.6719
          c-3.2012-1.7822-5.8652-4.165-7.9932-7.1523c-2.1279-2.9854-3.7285-6.4248-4.8008-10.3184s-1.6084-7.9688-1.6084-12.2246v-9.2061
          c0-2.8369,0.2393-5.6084,0.7178-8.3145c0.4775-2.7051,1.1875-5.2539,2.1279-7.6465c0.9404-2.3916,2.1113-4.6025,3.5137-6.6318
          s3.0518-3.7695,4.9492-5.2217c1.8975-1.4512,4.042-2.5898,6.4346-3.415c2.3916-0.8242,5.0234-1.2373,7.8936-1.2373
          c4.3555,0,8.1582,0.8906,11.4082,2.6729c3.249,1.7812,5.9639,4.166,8.1416,7.1514c2.1777,2.9863,3.8105,6.4424,4.8994,10.3691
          s1.6328,8.0176,1.6328,12.2734V62.7217z M121.6182,53.417c-0.0342-2.7051-0.2812-5.3945-0.7432-8.0674
          s-1.2373-5.0557-2.3262-7.1514c-1.0889-2.0947-2.5322-3.7939-4.3301-5.0977c-1.7988-1.3037-4.0508-1.9551-6.7559-1.9551
          c-2.6729,0-4.8916,0.6514-6.6562,1.9551c-1.7656,1.3037-3.168,3.0107-4.207,5.1221c-1.0391,2.1123-1.7656,4.4961-2.1777,7.1514
          c-0.4131,2.6562-0.6357,5.3379-0.668,8.043v9.3047c0.0322,2.7051,0.2637,5.3867,0.6924,8.042
          c0.4287,2.6562,1.1631,5.0488,2.2031,7.1768c1.0391,2.1279,2.4404,3.8525,4.2061,5.1719c1.7646,1.3203,3.9844,1.9795,6.6572,1.9795
          c2.7051,0,4.957-0.6592,6.7559-1.9795c1.7979-1.3193,3.2412-3.0352,4.3301-5.1475c1.0889-2.1113,1.8564-4.5039,2.3018-7.1758
          c0.4453-2.6729,0.6836-5.3623,0.7178-8.0674V53.417z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M168.4365,76.0352l14.9961-53.9961h12.9668l-22.2715,72.0605h-11.333l-22.2227-72.0605h12.9668
          L168.4365,76.0352z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M207.9316,22.0391h42.8604v9.8486h-15.5898v52.4121h15.5898v9.7998h-42.8604v-9.7998h15.2432
          V31.8877h-15.2432V22.0391z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M266.5791,94.0996V22.0391h17.6191c4.9492,0.0332,9.3955,0.8584,13.3379,2.4746
          c3.9424,1.6172,7.292,3.8936,10.0469,6.8301s4.875,6.4424,6.3604,10.5166c1.4844,4.0752,2.2432,8.5869,2.2764,13.5361v5.4443
          c-0.0332,4.9492-0.792,9.4609-2.2764,13.5361c-1.4854,4.0752-3.5967,7.5723-6.335,10.4922
          c-2.7393,2.9199-6.0557,5.1885-9.9482,6.8047c-3.8936,1.6172-8.2646,2.4258-13.1152,2.4258H266.5791z M278.6553,31.6406v52.9072
          h5.8896c3.2666-0.0332,6.1201-0.6191,8.5625-1.7578c2.4414-1.1377,4.4785-2.7383,6.1123-4.8008
          c1.6328-2.0615,2.8535-4.5439,3.6621-7.4482c0.8076-2.9033,1.2285-6.1367,1.2617-9.7002v-5.543
          c-0.0332-3.4648-0.4541-6.6318-1.2617-9.5029c-0.8086-2.8701-2.0381-5.3525-3.6875-7.4482
          c-1.6504-2.0947-3.7197-3.7285-6.2109-4.8994c-2.4922-1.1709-5.4199-1.7734-8.7852-1.8066H278.6553z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M372.5918,67.2744h-39.6436v-9.5518h39.6436V67.2744z"
            />
          </g>
          <g>
            <path
              style="fill:#33322D;"
              d="M431.1808,61.4101h-26.681v20.3555h31.2249v8.7311h-41.9599V25.6421h41.6479v8.8189h-30.9129
          v18.3076h26.681V61.4101z"
            />
            <path
              style="fill:#33322D;"
              d="M469.0872,49.7839l12.4726-24.1418h12.6053l-18.4851,32.1601l18.9308,32.6944h-12.5165
          l-12.8285-24.5435l-12.8285,24.5435H443.787l18.9308-32.6944l-18.4403-32.1601h12.5165L469.0872,49.7839z"
            />
            <path
              style="fill:#33322D;"
              d="M514.1645,65.6411v24.8555h-10.6901V25.6421h21.6923c3.2361,0.0299,6.228,0.5124,8.9754,1.4476
          c2.7457,0.9352,5.1144,2.272,7.1042,4.0087c1.989,1.7376,3.5411,3.8461,4.6547,6.3255s1.6708,5.2778,1.6708,8.3962
          c0,3.0287-0.5572,5.7612-1.6708,8.1958c-1.1136,2.4355-2.6657,4.5141-4.6547,6.2358c-1.9898,1.7227-4.3585,3.0445-7.1042,3.9647
          c-2.7474,0.9202-5.7393,1.3957-8.9754,1.4247H514.1645z M514.1645,56.9997h11.0021c1.8105,0,3.4295-0.2742,4.8551-0.8235
          s2.6429-1.314,3.6527-2.2939c1.009-0.98,1.7816-2.1524,2.3159-3.5191c0.5344-1.3658,0.8016-2.8503,0.8016-4.4543
          c0-1.6928-0.2672-3.2511-0.8016-4.6767c-0.5344-1.4256-1.3069-2.6508-2.3159-3.6747c-1.0098-1.0248-2.2271-1.8185-3.6527-2.3836
          c-1.4256-0.5634-3.0446-0.8605-4.8551-0.8903h-11.0021V56.9997z"
            />
            <path
              style="fill:#33322D;"
              d="M569.1304,81.7655h30.9129v8.7311h-41.603V25.6421h10.6901V81.7655z"
            />
            <path
              style="fill:#33322D;"
              d="M643.6054,75.4409h-20.2667l-4.4543,15.0557h-11.0469l21.0692-64.8545h9.3981l20.6683,64.8545
          h-11.0021L643.6054,75.4409z M626.0554,66.31h14.8781l-7.3503-25.4347L626.0554,66.31z"
            />
            <path
              style="fill:#33322D;"
              d="M668.3273,25.6421h38.5743v8.8638h-14.0309v47.1709h14.0309v8.8198h-38.5743v-8.8198h13.7189
          V34.5059h-13.7189V25.6421z"
            />
            <path
              style="fill:#33322D;"
              d="M763.6051,90.4966h-10.7798l-21.113-44.6326l-0.0449,44.6326h-10.8237V25.6421h10.8237
          l21.0244,44.4981l0.0896-44.4981h10.8237V90.4966z"
            />
            <path
              style="fill:#33322D;"
              d="M814.3831,61.4101h-26.681v20.3555h31.2249v8.7311h-41.9598V25.6421h41.6478v8.8189h-30.9129
          v18.3076h26.681V61.4101z"
            />
            <path
              style="fill:#33322D;"
              d="M830.5971,90.4966V25.6421h15.8572c4.4543,0.0299,8.4559,0.7726,12.0041,2.2271
          c3.5482,1.4555,6.5628,3.5042,9.0422,6.1471c2.4794,2.6429,4.3875,5.7981,5.7244,9.4649
          c1.3359,3.6677,2.0188,7.7282,2.0487,12.1825v4.8999c-0.0299,4.4543-0.7128,8.5148-2.0487,12.1825
          c-1.3369,3.6677-3.2371,6.815-5.7015,9.443c-2.4653,2.6279-5.4501,4.6696-8.9534,6.1242
          c-3.5042,1.4555-7.4382,2.1832-11.8037,2.1832H830.5971z M841.4657,34.2835V81.9h5.3007c2.9399-0.0299,5.5081-0.5572,7.7062-1.582
          c2.1973-1.0239,4.0307-2.4645,5.5011-4.3207c1.4695-1.8554,2.5682-4.0896,3.2959-6.7034c0.7269-2.613,1.1057-5.523,1.1356-8.7302
          V55.575c-0.0299-3.1184-0.4087-5.9687-1.1356-8.5526c-0.7277-2.5831-1.8343-4.8173-3.3188-6.7034
          c-1.4854-1.8853-3.3477-3.3557-5.5898-4.4095c-2.2429-1.0538-4.8779-1.5961-7.9066-1.626H841.4657z"
            />
          </g>
        </svg>

        <svg
          class="block sm:hidden sm-logo"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="543.855px"
          height="228.2773px"
          viewBox="0 0 543.855 228.2773"
          style="enable-background:new 0 0 543.855 228.2773;"
          xml:space="preserve"
        >
          <defs></defs>
          <path
            style="fill:#FFFFFF;"
            d="M361.5918,66.2744h-29.6435v-9.5518h29.6435V66.2744z"
          />
          <g>
            <rect
              x="1.0003"
              y="115.1382"
              style="fill:#FFFFFF;"
              width="541.855"
              height="112.1387"
            />
            <path
              style="fill:#33322D;"
              d="M541.855,116.1387v110.1387H2V116.1387H541.855 M543.855,114.1387H0v114.1387h543.855V114.1387
      		L543.855,114.1387z"
            />
          </g>
          <g>
            <g>
              <polygon
                style="fill:#33322D;"
                points="1.0003,113.1382 1.0003,0.9995 360.592,0.9995 360.592,55.7222 330.9485,55.7222
      			330.9485,67.2749 360.592,67.2749 360.592,113.1382 		"
              />
              <path
                style="fill:#33322D;"
                d="M359.5918,2v52.7227h-27.6436h-2v2v9.5518v2h2h27.6436v43.8643H2V2H359.5918 M361.5918,0H0
      			v114.1387h361.5918V66.2744h-29.6436v-9.5518h29.6436V0L361.5918,0z"
              />
            </g>
            <path
              style="fill:#FFFFFF;"
              d="M71.5215,70.9766c-0.3301,3.4639-1.1553,6.624-2.4746,9.4775
      		c-1.3203,2.8545-3.0684,5.2959-5.2461,7.3252c-2.1777,2.0293-4.7441,3.5967-7.6963,4.7012
      		c-2.9531,1.1055-6.2451,1.6582-9.874,1.6582c-4.3887,0-8.2158-0.8496-11.4824-2.5488c-3.2656-1.6992-5.9883-4-8.1655-6.9043
      		c-2.1777-2.9033-3.811-6.3018-4.8999-10.1953C20.5938,70.5976,20.0322,66.4404,20,62.0185v-9.8496
      		c0.0322-4.3877,0.6099-8.5371,1.7319-12.4473c1.1216-3.9092,2.7793-7.3242,4.9741-10.2441
      		c2.1943-2.9199,4.9248-5.2295,8.1914-6.9287C38.1631,20.8496,41.9571,20,46.2803,20c3.7939,0,7.1758,0.5605,10.1455,1.6826
      		s5.5098,2.7051,7.6221,4.751c2.1113,2.0459,3.7939,4.5371,5.0479,7.4736s2.0615,6.2031,2.4258,9.7988H59.6426
      		c-0.1973-2.1113-0.6016-4.0332-1.2119-5.7656c-0.6113-1.7324-1.4443-3.2168-2.5-4.4541s-2.3838-2.1855-3.9834-2.8457
      		c-1.6006-0.6602-3.4893-0.9902-5.667-0.9902c-2.6729,0-4.917,0.6113-6.7314,1.8311c-1.8145,1.2217-3.2832,2.8633-4.4043,4.9248
      		c-1.1221,2.0625-1.9229,4.4463-2.4004,7.1514c-0.4785,2.7061-0.7178,5.543-0.7178,8.5127v9.9482
      		c0,3.1016,0.2393,6.0127,0.7178,8.7354c0.4775,2.7217,1.2617,5.1064,2.3506,7.1514c1.0889,2.0459,2.541,3.6621,4.3555,4.8506
      		c1.8145,1.1875,4.0742,1.7812,6.7803,1.7812c4.1572,0,7.3252-1.1787,9.5029-3.5381s3.4639-5.7002,3.8604-10.0225H71.5215z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M132.5449,61.7217c0,4.2559-0.5439,8.3389-1.6328,12.249s-2.7148,7.3584-4.875,10.3438
      		c-2.1611,2.9863-4.8672,5.3623-8.1172,7.127s-7.0518,2.6475-11.4072,2.6475c-4.3232,0-8.085-0.8906-11.2842-2.6719
      		c-3.2012-1.7822-5.8652-4.165-7.9932-7.1523c-2.1279-2.9854-3.7285-6.4248-4.8008-10.3184s-1.6084-7.9688-1.6084-12.2246v-9.2061
      		c0-2.8369,0.2393-5.6084,0.7178-8.3145c0.4775-2.7051,1.1875-5.2539,2.1279-7.6465c0.9404-2.3916,2.1113-4.6025,3.5137-6.6318
      		s3.0518-3.7695,4.9492-5.2217c1.8975-1.4512,4.042-2.5898,6.4346-3.415c2.3916-0.8242,5.0234-1.2373,7.8936-1.2373
      		c4.3555,0,8.1582,0.8906,11.4082,2.6729c3.249,1.7812,5.9639,4.166,8.1416,7.1514c2.1777,2.9863,3.8105,6.4424,4.8994,10.3691
      		s1.6328,8.0176,1.6328,12.2734V61.7217z M120.6182,52.417c-0.0342-2.7051-0.2812-5.3945-0.7432-8.0674
      		s-1.2373-5.0557-2.3262-7.1514c-1.0889-2.0947-2.5322-3.7939-4.3301-5.0977c-1.7988-1.3037-4.0508-1.9551-6.7559-1.9551
      		c-2.6729,0-4.8916,0.6514-6.6562,1.9551c-1.7656,1.3037-3.168,3.0107-4.207,5.1221c-1.0391,2.1123-1.7656,4.4961-2.1777,7.1514
      		c-0.4131,2.6562-0.6357,5.3379-0.668,8.043v9.3047c0.0322,2.7051,0.2637,5.3867,0.6924,8.042
      		c0.4287,2.6562,1.1631,5.0488,2.2031,7.1768c1.0391,2.1279,2.4404,3.8525,4.2061,5.1719c1.7646,1.3203,3.9844,1.9795,6.6572,1.9795
      		c2.7051,0,4.957-0.6592,6.7559-1.9795c1.7979-1.3193,3.2412-3.0352,4.3301-5.1475c1.0889-2.1113,1.8564-4.5039,2.3018-7.1758
      		c0.4453-2.6729,0.6836-5.3623,0.7178-8.0674V52.417z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M167.4365,75.0351l14.9961-53.9961h12.9668l-22.2715,72.0605h-11.333l-22.2227-72.0605h12.9668
      		L167.4365,75.0351z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M206.9317,21.0391h42.8604v9.8486h-15.5898v52.4121h15.5898v9.7998h-42.8604v-9.7998h15.2432
      		V30.8877h-15.2432V21.0391z"
            />
            <path
              style="fill:#FFFFFF;"
              d="M265.5791,93.0996V21.0391h17.6191c4.9492,0.0332,9.3955,0.8584,13.3379,2.4746
      		c3.9424,1.6172,7.292,3.8936,10.0469,6.8301s4.875,6.4424,6.3604,10.5166c1.4844,4.0752,2.2432,8.5869,2.2764,13.5361v5.4443
      		c-0.0332,4.9492-0.792,9.4609-2.2764,13.5361c-1.4854,4.0752-3.5967,7.5723-6.335,10.4922
      		c-2.7393,2.9199-6.0557,5.1885-9.9482,6.8047c-3.8936,1.6172-8.2646,2.4258-13.1152,2.4258H265.5791z M277.6553,30.6406v52.9072
      		h5.8896c3.2666-0.0332,6.1201-0.6191,8.5625-1.7578c2.4414-1.1377,4.4785-2.7383,6.1123-4.8008
      		c1.6328-2.0615,2.8535-4.5439,3.6621-7.4482c0.8076-2.9033,1.2285-6.1367,1.2617-9.7002v-5.543
      		c-0.0332-3.4648-0.4541-6.6318-1.2617-9.5029c-0.8086-2.8701-2.0381-5.3525-3.6875-7.4482
      		c-1.6504-2.0947-3.7197-3.7285-6.2109-4.8994c-2.4922-1.1709-5.4199-1.7734-8.7852-1.8066H277.6553z"
            />
          </g>
          <g>
            <path
              style="fill:#33322D;"
              d="M68.589,174.5487h-26.681v20.3555H73.133v8.7311H31.1731v-64.8545H72.821v8.8189H41.9081v18.3076
      		h26.681V174.5487z"
            />
            <path
              style="fill:#33322D;"
              d="M106.4954,162.9225l12.4726-24.1418h12.6053l-18.4852,32.16l18.9308,32.6944h-12.5165
      		l-12.8285-24.5435l-12.8285,24.5435H81.1952l18.9308-32.6944l-18.4403-32.16h12.5165L106.4954,162.9225z"
            />
            <path
              style="fill:#33322D;"
              d="M151.5727,178.7798v24.8555h-10.6901v-64.8545h21.6923c3.2361,0.0299,6.2279,0.5124,8.9754,1.4476
      		c2.7457,0.9352,5.1143,2.272,7.1042,4.0087c1.989,1.7376,3.5411,3.8461,4.6547,6.3255c1.1136,2.4794,1.6708,5.2778,1.6708,8.3962
      		c0,3.0287-0.5572,5.7612-1.6708,8.1958c-1.1136,2.4355-2.6657,4.5141-4.6547,6.2358c-1.9899,1.7227-4.3585,3.0445-7.1042,3.9648
      		c-2.7475,0.9202-5.7393,1.3957-8.9754,1.4247H151.5727z M151.5727,170.1384h11.0022c1.8105,0,3.4295-0.2742,4.8551-0.8235
      		s2.6429-1.314,3.6527-2.2939c1.009-0.98,1.7815-2.1524,2.3159-3.5191c0.5344-1.3658,0.8016-2.8503,0.8016-4.4543
      		c0-1.6928-0.2672-3.2511-0.8016-4.6767c-0.5344-1.4256-1.3069-2.6508-2.3159-3.6747c-1.0099-1.0248-2.2272-1.8185-3.6527-2.3836
      		c-1.4256-0.5634-3.0445-0.8605-4.8551-0.8903h-11.0022V170.1384z"
            />
            <path
              style="fill:#33322D;"
              d="M206.5386,194.9042h30.9129v8.7311h-41.603v-64.8545h10.6901V194.9042z"
            />
            <path
              style="fill:#33322D;"
              d="M281.0136,188.5796h-20.2667l-4.4543,15.0557h-11.047l21.0692-64.8545h9.3981l20.6684,64.8545
      		h-11.0021L281.0136,188.5796z M263.4637,179.4486h14.8781l-7.3503-25.4347L263.4637,179.4486z"
            />
            <path
              style="fill:#33322D;"
              d="M305.7355,138.7808h38.5743v8.8638H330.279v47.1709h14.0309v8.8198h-38.5743v-8.8198h13.7189
      		v-47.1709h-13.7189V138.7808z"
            />
            <path
              style="fill:#33322D;"
              d="M401.0133,203.6353h-10.7798l-21.1131-44.6326l-0.0448,44.6326h-10.8237v-64.8545h10.8237
      		L390.1,183.2789l0.0896-44.4981h10.8237V203.6353z"
            />
            <path
              style="fill:#33322D;"
              d="M451.7913,174.5487h-26.681v20.3555h31.2249v8.7311h-41.9599v-64.8545h41.6479v8.8189h-30.9129
      		v18.3076h26.681V174.5487z"
            />
            <path
              style="fill:#33322D;"
              d="M468.0053,203.6353v-64.8545h15.8572c4.4543,0.0299,8.4559,0.7726,12.0041,2.2271
      		c3.5482,1.4555,6.5628,3.5042,9.0422,6.1471c2.4794,2.6429,4.3875,5.7982,5.7243,9.465c1.3359,3.6677,2.0189,7.7282,2.0487,12.1825
      		v4.8999c-0.0298,4.4543-0.7128,8.5148-2.0487,12.1825c-1.3368,3.6677-3.237,6.815-5.7015,9.443
      		c-2.4653,2.6279-5.4501,4.6696-8.9534,6.1242c-3.5042,1.4555-7.4382,2.1832-11.8037,2.1832H468.0053z M478.8739,147.4222v47.6165
      		h5.3007c2.9399-0.0299,5.5081-0.5572,7.7062-1.582c2.1973-1.0239,4.0307-2.4644,5.5011-4.3207
      		c1.4695-1.8554,2.5682-4.0895,3.2959-6.7034c0.7269-2.613,1.1057-5.523,1.1356-8.7302v-4.9887
      		c-0.0299-3.1184-0.4087-5.9687-1.1356-8.5526c-0.7277-2.5831-1.8343-4.8173-3.3188-6.7034
      		c-1.4854-1.8853-3.3477-3.3557-5.5898-4.4095c-2.243-1.0538-4.8779-1.5961-7.9066-1.626H478.8739z"
            />
          </g>
        </svg>
      </router-link>
    </a>

    <div class="menu-wrapper">
      <div class="flex  items-center  w-auto w-full" id="menu">
        <div class="nav flex bg-gray-100">
          <div>
            <router-link :to="{ name: 'Glossary' }">Glossary</router-link>
          </div>

          <div>
            <a href="#">
              <router-link :to="{ name: 'AboutUs' }">About Us</router-link>
            </a>
          </div>
          <div>
            <a href="#">
              <router-link :to="{ name: 'ContactUs' }">Contact Us</router-link>
            </a>
          </div>
        </div>
      </div>
    </div>

    <ul class="if-admin">
      <li v-if="adminFromDb && canSeeApprovals">
        <a class="white-text admin-links">
          <router-link :to="{ name: 'AdminApproval' }"
            >Admin Approval</router-link
          >
        </a>
      </li>
      <li v-if="adminFromDb && canSeeInbox">
        <a class="white-text admin-links">
          <router-link :to="{ name: 'Inbox' }">Inbox</router-link>
        </a>
      </li>
      <li v-if="adminFromDb">
        <a href="#">
          <a class="white-text admin-links" @click="redirectToAddPost"
            >Create New Post</a
          >
        </a>
      </li>
      <li v-if="adminFromDb">
        <a href="#">
          <a class="white-text admin-links" @click="logout">Log Out</a>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/firebase/init';
export default {
  data: () => {
    return {
      admin: null,
      adminFromDb: null,
      canSeeApprovals: false,
      canSeeInbox: false,
      isApproved: false,
    };
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: 'AdminLogin' });
        });
    },
    redirectToAddPost() {
      this.$router.push({ name: 'AddPost' });
    },

    checkApprovalStatus(adminId) {
      db.collection('users')
        .doc(adminId)
        .get()
        .then(doc => {
          let adminFromDb = doc.data();
          adminFromDb.id = doc.id;
          this.adminFromDb = adminFromDb;
        });
    },

    checkIfAdminCanSeeApprovals() {
      if (
        this.authAdmin.email === 'emily_oster@brown.edu' ||
        this.authAdmin.email === 'oehrenmarks@gmail.com'
      ) {
        this.canSeeApprovals = true;
      } else {
        this.canSeeApprovals = false;
      }
    },
    checkIfAdminCanSeeInbox() {
      if (
        this.authAdmin.email === 'emily_oster@brown.edu' ||
        this.authAdmin.email === 'oehrenmarks@gmail.com' ||
        this.authAdmin.email === 'david_wingate@brown.edu' ||
        this.authAdmin.email === 'anagha_lokhande@brown.edu'
      ) {
        this.canSeeInbox = true;
      } else {
        this.canSeeInbox = false;
      }
    },
  },
  created() {
    this.authAdmin = firebase.auth().currentUser;
    firebase.auth().onAuthStateChanged(admin => {
      if (admin) {
        this.authAdmin = admin;
        this.checkApprovalStatus(this.authAdmin.uid);
        this.checkIfAdminCanSeeApprovals();
        this.checkIfAdminCanSeeInbox();
      } else {
        this.authAdmin = null;
      }
    });
  },
};
</script>

<style scoped>
.container {
  z-index: 3;
}
.nav {
  padding: 1rem;
}

.nav div {
  padding: 0 1rem;
}

.container .if-admin {
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 105;
  display: flex;
}

.nav div:hover {
  opacity: 0.75;
}

.admin-links {
  font-size: 12px;
  background: black;
  color: white;
  padding: 1rem 1rem;
  border: 1px solid white;
}
.menu-wrapper {
  position: absolute;
  z-index: 100;
  top: 20px;
  right: 40px;
}

.site-name {
  position: absolute;
  top: 30px;
  left: 40px;
  padding: 0;
  font-size: 20px;
  z-index: 5;
}

.site-name svg {
  width: 300px;
  height: auto;
}

@media (max-width: 1024px) {
  .site-name svg {
    width: 200px;
    height: auto;
  }
}

@media (max-width: 640px) {
  .nav {
    padding: 1rem 0rem;
    font-size: 11px;
  }
  .site-name {
    top: 10px;
    left: 10px;
  }
  .menu-wrapper {
    top: 10px;
    right: 10px;
  }
  .site-name svg {
    width: 100px;
    height: auto;
  }
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue